import React, { useEffect, useState } from "react";
import SearchBarPrimary from "../../components/searchbar/SearchBarPrimary";
import Footer from "../../layout/Footer";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getConfig, searchAPI } from "../../apis";
import { Link, useNavigate } from "react-router-dom";
import { logEvent } from "../../functions/amplitude";
import { useSelector } from "react-redux";
import Datepicker from "../../components/datepicker/Datepicker";
import { axiosInstance } from "../../functions/axios";
import { useDispatch } from "react-redux";
import {
  setsidebarData,
  setsidebarDataCopy,
} from "../../redux/features/dataSlice";
import CloseIcon from "@mui/icons-material/Close";
import VimeoPlayer from "../../components/VimeoPlayer/VideoPlayer";

const Landing = () => {
  const [searchList, setsearchList] = useState([]);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [customSearch, setCustomSearch] = useState();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { datePicker } = useSelector((state) => state.data);

  async function getQuickSearch() {
    try {
      const res = await axiosInstance.post(searchAPI.quickSearch, {
        numberToSelect: 6,
      });

      setsearchList(res.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  const checkSharedBookmark = () => {
    if (localStorage.getItem("code")) {
      const code = localStorage.getItem("code");
      const collectionName = localStorage.getItem("collectionName");
      navigate(
        `/verifySharedCollection?code=${code}&collectionName=${collectionName}`
      );
    }
  };

  const checkUserFromStorage = () => {
    let user = {};
    if (sessionStorage.getItem("user")) {
      user = JSON.parse(sessionStorage.getItem("user"));
    } else {
      user = JSON.parse(localStorage.getItem("user"));
    }
    return user;
  };

  async function getData() {
    const user = checkUserFromStorage();

    try {
      const sidebar = await axiosInstance.post(searchAPI.sidebar, {
        callingUserId: user?.userId,
        userId: user?.userId,
        includeDeletedRecords: 0,
      });
      dispatch(setsidebarData(sidebar.data));
      dispatch(setsidebarDataCopy(sidebar.data));
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getData();
    getQuickSearch();
    checkSharedBookmark();
  }, []);

  return (
    <div className="landing-page">
      <div className="landing-top">
        <div className="top-wrapper">
          <h1 className="logo">
            Sooth<span>.</span>
          </h1>
        </div>
        <SearchBarPrimary
          placeholder="Start Researching..."
          results={[]}
          onFocus={() => null}
          customSearch={customSearch}
          setCustomSearch={setCustomSearch}
        />
      </div>
      {datePicker && <Datepicker />}
      {selectedVideoId && (
        <VimeoPlayer
          selectedVideoId={selectedVideoId}
          setSelectedVideoId={setSelectedVideoId}
        />
      )}
      <div className="landing-bottom">
        {searchList.length ? (
          <div className="landing-info">
            <div className="flex">
              <h3>Quick Search</h3>
              <RefreshIcon onClick={getQuickSearch} />
            </div>

            <div className="landing-list">
              {searchList.map((item) => (
                <Link
                  to={item.link_chr}
                  key={item.quickSearch_chr}
                  onClick={() =>
                    logEvent(`click_curious_query`, {
                      quicksearch: item.quickSearch_chr,
                    })
                  }
                >
                  {item.quickSearch_chr}
                </Link>
              ))}
            </div>
          </div>
        ) : null}
        <Footer
          selectedVideoId={selectedVideoId}
          setSelectedVideoId={setSelectedVideoId}
        />
      </div>
    </div>
  );
};

export default Landing;
